//Please add the language resource
const monthBill = {
  interfaceName: 'interfaceName',
  accountPeriod: 'accountPeriod',
  carNums: 'carNums',
  callCount: 'callCount',
  cost: 'cost',
  msg: {}
};
export default monthBill




// WEBPACK FOOTER //
// ./src/page/bill/monthBill/lang/monthBill.en.js